<template>
    <div>
        <b-modal
            no-close-on-esc
            no-close-on-backdrop
            size="xl"
            hide-footer
            v-model="showModal"
            :title="getTitle"
            scrollable
        >
            <div v-if="loading" class="mb-3">
                <b-spinner
                    id="loadingSpinner"
                    small
                    style="align-self: center"
                    label="Loading"
                    variant="primary"
                />
            </div>
            <div v-if="tableData.length > 0">
                <p>{{ this.headerText }}</p>
                <b-table striped:hover :items="tableData"></b-table>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: 'nedglobeservices-table-content',

        props: {
            launchModal: { type: Boolean, required: false, default: false },
            tableName: { type: String, required: true, default: '' }
        },

        data() {
            return {
                showModal: false,
                loading: false,
                tableData: [],
                recordCount: '',
                limit: 100
            };
        },
        computed: {
            getTitle() {
                return `${this.tableName}: ${this.$t(
                    'nedglobeServices.tables.recordCount'
                )} : ${this.recordCount}`;
            },

            headerText() {
                const records = Math.min(this.tableData.length, this.recordCount);
                return this.$t('nedglobeServices.tables.firstRecords', [records]);
            }
        },

        methods: {
            async $_showDomainModal() {
                this.tableData = [];
                this.showModal = true;
                this.loading = true;
                this.recordCount = '';

                // Get number of records
                let result = await this.$store.dispatch('useApiData', {
                    name: 'GetTableRecordCount',
                    parameters: { TableName: this.tableName }
                });

                this.recordCount = result.data;

                // Get table data.
                result = await this.$store.dispatch('useApiData', {
                    name: 'GetTableDataOverview',
                    parameters: { TableName: this.tableName },
                    // API already supports pagination
                    // Get the first {limit} starting at 0.
                    data: { Limit: this.limit, OffSet: 0 }
                });
                this.tableData =
                    result.data && result.data.length > 0
                        ? JSON.parse(result.data)
                        : [];

                this.loading = false;
            },

            $_hideModal() {
                this.showModal = false;
            }
        },

        watch: {
            launchModal() {
                this.$_showDomainModal();
            }
        }
    };
</script>
